(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloDetailController', RuoloDetailController);

    RuoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ruolo', 'RuoloFunzione'];

    function RuoloDetailController($scope, $rootScope, $stateParams, previousState, entity, Ruolo, RuoloFunzione) {
        var vm = this;

        vm.ruolo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:ruoloUpdate', function(event, result) {
            vm.ruolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
